import React from "react";
import box from "../../../assets/media/icon/empty-white-box.svg";
import { useNavigate } from "react-router-dom";
import LinksGridRow from "./Sub/LinksGridRow";
const GridView = ({
  filter,
  links,
  selectedLinkSIndex,
  setSelectedLinkSIndex,
}) => {
  return (
    <div className="mt-20px">
      <div className="rounded-lg border border-primary-100 dark:border-none bg-white dark:bg-accent-800 overflow-hidden">
        <div className="text-primary-900 dark:text-accent-200 md:text-lg text-base font-semibold pt-16px md:px-25px px-16px pb-10px border-b border-primary-100 dark:border-accent-600">
          {filter} links
        </div>
        <div className="w-full overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr>
                <th className="md:py-12px py-10px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-none bg-[#f7f7f9] dark:bg-accent-700 text-left text-accent-400 dark:text-accent-200">
                  Title
                </th>
                <th className="md:py-12px py-10px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-none bg-[#f7f7f9] dark:bg-accent-700 text-left text-accent-400 dark:text-accent-200">
                  Date
                </th>
                <th className="md:py-12px py-10px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-none bg-[#f7f7f9] dark:bg-accent-700 text-left text-accent-400 dark:text-accent-200">
                  Status
                </th>
                <th className="md:py-12px py-10px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-none bg-[#f7f7f9] dark:bg-accent-700 text-left text-accent-400 dark:text-accent-200">
                  Original
                </th>
                <th className="md:py-12px py-10px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-none bg-[#f7f7f9] dark:bg-accent-700 text-left text-accent-400 dark:text-accent-200">
                  Short
                </th>
                <th className="md:py-12px py-10px text-sm md:px-25px px-16px border-b border-accent-50 dark:border-none bg-[#f7f7f9] dark:bg-accent-700 text-left text-accent-400 dark:text-accent-200">
                  Clicks
                </th>
              </tr>
            </thead>
            <tbody>
              {links &&
                links.map((link, index) => (
                  <LinksGridRow
                    key={index} // Provide unique index as the key
                    title={link.title}
                    date={link.dateCreated}
                    status={link.status}
                    original={link.original}
                    shorten={link.shorten}
                    clicks={link.clicks}
                    index={index}
                    selectedLinkSIndex={selectedLinkSIndex}
                    setSelectedLinkSIndex={setSelectedLinkSIndex}
                  />
                ))}
              {!links && <EmptyBox />}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
function EmptyBox() {
  const Nav = useNavigate();
  return (
    <tr>
      <td colSpan={6}>
        <div className="py-48px px-25px text-center text-accent-300">
          You have no links yet
        </div>
      </td>
    </tr>
  );
}
export default GridView;
